export const UNSUPPORTED = {code:-1, label:"UNSUPPORTED"};
export const UNKNOWN = {code:0, label:"UNKNOWN"};
export const VERSION_4 = {code:1, label:"VERSION 4"};
export const VERSION_6 = {code:2, label:"VERSION 6"};


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/enums/IpProtocolEnum.js